import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useSelector } from "react-redux";
const tableHead = [
  "Sr.",
  "Project",
  "Date of Creation",
  "lenth of structure",
  "width of structure",
  "Actions",
];
const StructureUtilizationTable = ({ CP = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const user = useSelector((store) => store.login.user.Role);

  const goToView = (id) => {
    navigate(`/view-structure-utilization/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {CP.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            // const { statusText, isCompleted } = getTaskListDetails(item?.taskList);

            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.projectName || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.totalenHocky || "N/A"}m</td>
                <td>{item?.totawidHocky || "N/A"}m</td>
                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StructureUtilizationTable;
